import About from "./components/About";
import ContactMe from "./components/ContactMe";
import LandingPage from "./components/LandingPage";
import Skills from "./components/Skills";
import Works from "./components/Works";
import Navbar from "./components/Navbar";
import './App.css'
import Education from "./components/Education";
import Experience from "./components/Experience";

function App() {
  return (
    <>
      <div className="app overflow-x-hidden">
        <Navbar />
        <LandingPage />
        <About />
        <Education />
        <Skills /> 
        <Experience />
        <Works />
        <ContactMe />
      </div>
    </>
  );
}

export default App;
